import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const MoreIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="smallIcon" opacity="0.5">
        <g id="Vector">
          <path
            d="M6 8.38281C6 8.9351 5.55228 9.38281 5 9.38281C4.44772 9.38281 4 8.9351 4 8.38281C4 7.83053 4.44772 7.38281 5 7.38281C5.55228 7.38281 6 7.83053 6 8.38281Z"
            fill={fillColor || '#D4D5D5'}
          />
          <path
            d="M9 8.38281C9 8.9351 8.55228 9.38281 8 9.38281C7.44772 9.38281 7 8.9351 7 8.38281C7 7.83053 7.44772 7.38281 8 7.38281C8.55228 7.38281 9 7.83053 9 8.38281Z"
            fill={fillColor || '#D4D5D5'}
          />
          <path
            d="M12 8.38281C12 8.9351 11.5523 9.38281 11 9.38281C10.4477 9.38281 10 8.9351 10 8.38281C10 7.83053 10.4477 7.38281 11 7.38281C11.5523 7.38281 12 7.83053 12 8.38281Z"
            fill={fillColor || '#D4D5D5'}
          />
        </g>
      </g>
    </svg>
  );
};

export { MoreIcon };
